import { render } from "./AlarmLamp.vue?vue&type=template&id=2fb2864e"
import script from "./AlarmLamp.vue?vue&type=script&lang=js"
export * from "./AlarmLamp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__